import type { RowValues } from 'ui/components/HourlyDataTable/HourlyDataTable.types'
import { parseElplanCellKey } from './cells.adapter'
import { toStoredSlotEdits } from './draft'
import type { ElplanDraft, ElplanSlotEdit } from './ElplanEditor.types'

export function toSlotEditsOfRowWrite(
  previous: readonly RowValues[],
  next: readonly RowValues[],
  draft: ElplanDraft
): ElplanSlotEdit[] {
  return next.flatMap((row, rowIndex) =>
    Object.entries(row).flatMap(([cellKey, text]) => {
      const slot = previous[rowIndex]?.[cellKey] === text ? null : parseElplanCellKey(cellKey)
      return slot ? toStoredSlotEdits(slot, text, draft) : []
    })
  )
}

export function clearRowCells(rows: readonly RowValues[], cellKeys: ReadonlySet<string>): RowValues[] {
  return rows.map((row) => {
    const clearedKeys = Object.keys(row).filter((cellKey) => cellKeys.has(cellKey))
    return clearedKeys.length === 0
      ? row
      : { ...row, ...Object.fromEntries(clearedKeys.map((cellKey) => [cellKey, ''])) }
  })
}
